module.exports = __webpack_public_path__ + "static/media/20.39e96986.jpg";